interface SkeletonProps { className?: string }
export function Skeleton({ className = "" }: SkeletonProps) {
  return <div className={`bg-bone/80 animate-pulse ${className}`} />;
}

export function ItemGridSkeleton({ count = 8 }: { count?: number }) {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
      {Array.from({ length: count }).map((_, i) => (
        <div key={i} className="border border-border bg-background">
          <Skeleton className="aspect-[4/5]" />
          <div className="p-4 space-y-2">
            <Skeleton className="h-3 w-1/3" />
            <Skeleton className="h-4 w-3/4" />
            <Skeleton className="h-3 w-1/2" />
          </div>
        </div>
      ))}
    </div>
  );
}
